import { createContext, useContext } from 'react';

interface BackupTypeContextType {
	type: string;
	setType: React.Dispatch<React.SetStateAction<string>>;
}
const BackupTypeContext = createContext<BackupTypeContextType>({
	type: 'None',
	setType: () => {},
});

export const BackupTypeProvider = BackupTypeContext.Provider;
export const useBackupTypeContext = () => {
	const context = useContext(BackupTypeContext);
	if (!context) {
		throw new Error(
			'useBackupTypeContext must be used within a BackupTypeProvider',
		);
	}

	return context;
};

export default BackupTypeContext;
